
<div class="_flex _justify-between _pb-3 _border-b _border-transparency-black-5 _shadow-bottom">
    <div>More Filters <span *ngIf="selectedFiltersCount" class="_text-md _text-primary-1-tint-50">({{selectedFiltersCount}} selected)</span></div>
    <i class="fa-light fa-xmark _cursor-pointer" mat-dialog-close></i>
</div>

<mat-dialog-content class="_no-scrollbar">
    <app-search-filters-extended
        [moreFilters]="moreFilters"
        [listingCount]="listingCount"
        ($selectedFilterCountChanged)="selectedFilterCountChanged($event)"
        ($moreFiltersChange)="moreFiltersChanged($event)">
    </app-search-filters-extended>
</mat-dialog-content>

<div class="_flex _justify-between _items-center _pt-3 _shadow-top">
    <div class="_text-primary-1-tint-50 _cursor-pointer" (click)="clearAllFilters()">
        <span class="_text-md _mr-2">Reset all fitlers</span>
        <i class="fa-light fa-arrows-rotate _text-md"></i>
    </div>
    <button class="_button-primary" mat-dialog-close>View {{listingCount}} listings</button>
</div>

